









































































































































































import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"

@Component({
    components: {JdsButton, JdiCodeBlock, JdiStatus, JdiContent}
})
export default class Installation extends Vue {
}
